// @flow
import $ from 'jquery';
import JQueryView from '../../common/JQueryView';
import { on } from '../../../../admin/views/common/JQueryView';

export default class ChangeSearchInput extends JQueryView {
  constructor() {
    super('.search_form');
  }

  @on({ event: 'click', selector: '.search-condition-icon' })
  onClickSerachFormToggle(event: any) {
    var targetForm = $('.search-condition-body');
    var targetIcon = $(event.target);
    if (targetForm.hasClass('search-condition-none')) {
      targetForm.removeClass('search-condition-none');
      targetIcon.removeClass('form-close');
    } else {
      targetIcon.addClass('form-close');
      targetForm.addClass('search-condition-none');
    }
  }

  @on({ event: 'click', selector: '.dropdown-menu' })
  stopPropagation(event: any) {
    event.stopPropagation();
  }

  @on({
    event: 'change',
    selector: 'input:not([type=checkbox]), #form-id select',
  })
  onChangeSubmitSearch() {
    $('#form-id').submit();
  }

  @on({ event: 'change', selector: '.check-all' })
  onChangeAllCheckOptionCheckAll(event: any) {
    if ($(event.target).is(':checked')) {
      $(event.target)
        .parents('.dropdown-menu')
        .find('.check-single')
        .prop('checked', true);
    } else {
      $(event.target)
        .parents('.dropdown-menu')
        .find('.check-single')
        .prop('checked', false);
    }
  }

  @on({ event: 'change', selector: '.check-single' })
  onChangeOptionsChangeAllCheckOption(event: any) {
    const $dropdownMenu = $(event.target).parents('.dropdown-menu');
    if (
      $dropdownMenu.find('.check-single:checked').length ===
      $dropdownMenu.find('.check-single').length
    ) {
      $dropdownMenu.find('.check-all').prop('checked', true);
    } else {
      $dropdownMenu.find('.check-all').prop('checked', false);
    }
  }
}
